import { forwardRef } from 'react';
// icons
import { Icon } from '@iconify/react';
// @mui
import Box, { BoxProps } from '@mui/material/Box';
//
import { IconifyProps } from './types';

// ----------------------------------------------------------------------

interface Props extends Omit<BoxProps, 'component'> {
  icon: IconifyProps;
  width?: string | number;
}

const Iconify = forwardRef<HTMLDivElement, Props>(({ icon, width = 20, sx, ...other }, ref) => (
  <Box
    ref={ref}
    className="component-iconify"
    sx={{ width, height: width, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', ...sx }}
    {...other}
  >
    <Icon icon={icon} width={width} height={width} />
  </Box>
));

export default Iconify;
